angular.module('env.data.models.addressModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("AddressModel",
            {
                extend: ['BaseModel'],
                url: "addresses",
                fields: {
                    line1: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    line2: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    city: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    companyName: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    contactLastName: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    contactFirstName: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    contactTitle: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    country: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    email: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    postalCode: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    region: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    telephone: {
                        type: RepresentationModelFieldTypes.STRING
                    }
                }
            }
        );
    })

;